import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { setReadMeterRoute } from '../lib/firestore/readMeter'

// Points the Firestore read meter at the current route, flushing the previous
// route's reads.
export function useReadMeter() {
  const { pathname } = useLocation()
  useEffect(() => setReadMeterRoute(pathname), [pathname])
}
